const contextTypes = ['no.context', 'automatic', 'manually'];

export const getLLMContextType = (contextType) => {
    return contextTypes[contextType - 1] ?? "N/A";
}